import Udesk from 'Udesk';
import SdkLoaderBase from 'Component/common/sdk-loader-base';
import UdeskLocales from 'UdeskLocales';

class AgentReportComponent extends SdkLoaderBase {
    privates = {
        renderContainerId: 'customer-service-score',
        pageTitle:
            /* 客服成绩 */ UdeskLocales['current'].pages.dataAnalysis.customerServiceScore.index
                .customerServiceResults,
    };
}

export default Udesk.react.udeskify(AgentReportComponent);
